import { isFunction } from '@dxb-web-ui-framework/common/utils/Helper';
import { Button } from '@dxb-web-ui-framework/design-system';
import { ArrowForward as ArrowForwardIcon } from '@dxb-web-ui-framework/design-system/dist/icons';
import React, { FC, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export interface ViewAllButtonProps {
  dataTestId: string;
  title: string;
  navigateTo?: string;
  color?: 'inherit' | 'primary' | 'secondary' | 'default';
  variant?: 'text' | 'outlined' | 'contained';
  size?: 'small' | 'large';
  isLoading?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement> & React.MouseEventHandler<HTMLAnchorElement>;
}

const ViewAllButton: FC<ViewAllButtonProps> = ({
  dataTestId,
  title,
  variant,
  color,
  size,
  onClick,
  navigateTo,
  isLoading,
  children,
}) => {
  let navigate = useNavigate();

  const onClickHandler = useCallback(
    (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      if (onClick && isFunction(onClick)) {
        onClick(e);
        return;
      }

      navigate(navigateTo ? navigateTo : '/');
    },
    [navigateTo, navigate, onClick],
  );

  return (
    <Button
      variant={variant ? variant : 'text'}
      data-testid={dataTestId}
      title={title}
      onClick={onClickHandler}
      color={color ? color : 'primary'}
      size={size}
      hasSkeleton={isLoading}
      endIcon={<ArrowForwardIcon />}>
      {children}
    </Button>
  );
};

export { ViewAllButton };
